import Color from 'color';

/**
 * Side-effect-free leaf holding the brand/UI color literals shared between the
 * MUI theme and slate presence coloring. It deliberately imports nothing from
 * `../slate-api`, `../rendering`, or `@aline/graphql`: the modules that used to
 * own these values (`constants.ts`, `util/presence-color.ts`) run
 * module-scoped side effects on import, so pulling a single color from them
 * dragged the entire editor/GraphQL graph into consumers like the standalone
 * Teams channel-interaction page. Keeping the constants here lets the theme
 * import them without that fan-out, while the original modules re-export them
 * so their public API is unchanged.
 */
export const linkColor = 'rgb(20, 110, 232)';
export const INITIAL_USER_EDIT_COLOR = Color.rgb(0, 0, 245).toString();
export const INITIAL_USER_DELETE_COLOR = Color.rgb(203, 62, 62).toString();
